<template>
    <div
        class="card has-background-white-bis base-card"
        :class="[appContext]"
        @click.capture="checkForPendingInvite"
    >
        <div
            :class="{'card-invite-wrapper': this.base.isPendingInvite }"
        >
            <i
                class="far fa-envelope fa-3x base-invite-icon animation-horizontal"
                v-if="this.base.isPendingInvite"
            ></i>
            <div class="card-wrapper">
                <div class="card-header has-background-light">
                    <a class="card-header-title title is-6 has-truncated-text mb-0"
                       v-if="availableState.isAvailable"
                        :href="baseUrl" :title="base.name"
                        @click="showBitrixAttachRequirmentMsg"
                    >
                        {{ base.name }}
                    </a>
                    <div
                        v-else
                        class="card-header-title title is-6 has-truncated-text mb-0"
                        :title="base.name"
                        @click="showBitrixAttachRequirmentMsg"
                    >
                        {{ base.name }}
                    </div>


                    <div
                        class="base-status-icon"
                        :class="base.portal_icon.css_class"
                        :title="base.portal_icon.message"
                        >&nbsp;</div>
                    <div
                        class="base-status-icon last-icon"
                        :class="base.status_icon.color"
                    >
                        <i
                            :class="base.status_icon.css_class"
                            :title="licenseIconMessage"
                            @dblclick="showActivateLicenseModal(base)"
                        ></i>
                    </div>
                </div>

                    <div class="card-content subtitle" ref="descriptionContainer"
                        :class="{ expandable: isExpandable, expanded: isExpanded }"
                        @click="toggleDescription"
                    >
                        <div v-if="isExpandable" class="expand-content-toggle"
                             :title="trans.element[`${isExpanded ? 'collapse' : 'expand'}_description`]"
                        >
                            <i class="fas fa-lg"></i>
                        </div>
                        {{ base.description }}
                    </div>

                <footer v-if="base.permissions.manage" class="card-footer has-text-justified">
                    <a v-if="isBx24Context || isPortalContext || isAdmin24Context" :href="attachBaseUrl"
                        class="card-footer-item bitrix-attach-button"
                        :title="trans.element.attach_to_portal"
                        @click="attachBase"
                    >
                        <span class="icon">
                            <i class="fas fa-plus-circle"></i>
                        </span>
                        <span>{{ trans.element.context }}</span>
                    </a>

                    <a v-if="!isBx24Context && !isPortalContext && !isAdmin24Context" :title="trans.element.edit_base"
                        class="card-footer-item"
                        :href="editUrl"
                    >
                        <i class="fas fa-pencil-alt"></i>
                    </a>

                    <a v-if="!isBx24Context && !isPortalContext && !isAdmin24Context" :title="trans.element.delete_base"
                        class="card-footer-item delete-button"
                       :class="{
                            'disabled':!base.canDelete || !availableState.isAvailable,
                        }"
                        @click="showDeleteModal(base)"
                    >
                        <i class="far fa-trash-alt"></i>
                    </a>

                    <a v-if="isDefaultContext" :title="locElements.activate_license"
                        class="card-footer-item lic-button"
                       :class="{
                            'disabled': !base.canEditLicense,
                        }"
                        @click="showActivateLicenseModal(base)"
                    >
                        <i class="fas fa-key"></i>
                    </a>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        props: {
            base: Object,
        },
        data() {
            return {
                isPortalContext: isPortalContext,
                isBx24Context: isBx24Context,
                isDefaultContext: isDefaultContext,
                isAdmin24Context: isAdmin24Context,
                appContext: appContext,
                isExpandable: false,
                isExpanded: false,
                locElements: licenseLocalization.locElements,
                legacyImportStatusUrl: legacyImportStatusUrl,
                availableState: this.base.availableState
            }
        },
        computed: {
            licenseIconMessage() {
                let message = this.base.status_icon.message;
                let regExp = /<br \/>/g;
                message = message.replace(regExp, '\n');

                return message;
            },
            attachBaseUrl() {
                return actions.attachBaseToPortal.replace(
                    'base_hash',
                    this.base.hash_id);
            },
            baseUrl() {
                if (this.isBx24Context) return '#';

                return `${this.actions.show}/${this.base.hash_id}`;
            },
            editUrl() {
                return `${this.actions.edit}/${this.base.hash_id}`;
            },
            attachBaseMessage() {
                let message = '';

                switch (true) {
                    case this.isAdmin24Context:
                        message = this.trans.msg.base_will_be_attached_to_admin24;
                        break;
                    case this.isBx24Context:
                        message = this.trans.msg.base_will_be_attached_to_bx24;
                        break;
                    case this.isPortalContext:
                        message = this.trans.msg.base_will_be_attached_to_bx24;
                        break;
                }

                return message;
            },
            ...mapState('baseList', [ 'trans', 'actions' ]),
        },
        mounted() {
            let descriptionContainer = this.$refs.descriptionContainer;

            if (descriptionContainer.clientHeight < descriptionContainer.scrollHeight) {
                this.isExpandable = true;
            }
        },
        methods: {
            checkForPendingInvite(e) {
                if (this.base.isPendingInvite) {
                    this.showBaseInviteAcceptModal(this.base);
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            showBitrixAttachRequirmentMsg(e) {
                if (this.isBx24Context || this.isPortalContext || this.isAdmin24Context) {
                    let message = this.trans.msg.portal_attach_required;

                    let messageData = {
                        messageText: message,
                        cancelText: '',
                    };
                    this.openMessageBox(messageData);
                    e.preventDefault();
                }

                if (!this.availableState.isAvailable) {
                    let message = this.availableState.message;

                    let messageData = {
                        messageText: message,
                        cancelText: '',
                    };
                    this.openMessageBox(messageData);
                    e.preventDefault();
                }

                return;
            },
            attachBase(e) {
                let result = true;
                if (this.isBx24Context || this.isPortalContext || this.isAdmin24Context) {
                    let message = this.attachBaseMessage;
                        message = message.replace('base_name', this.base.name);

                    const baseAttachedMessage = this.getBaseAttachedMessage();
                    if (baseAttachedMessage) {
                        message += '<br/><br/>' + baseAttachedMessage;
                    }

                    var regExp = /<br \/>/g;
                    message = message.replace(regExp, '\n');

                    let messageData = {
                        messageText: message,
                        okText: this.trans.element.continue,
                        okCallback: this.attacheBaseCallback,
                    };
                    this.openMessageBox(messageData);
                    e.preventDefault();
                }
                return result;
            },
            getBaseAttachedMessage() {
                if (!this.base.licensing_info) return '';

                const baseState = this.base.licensing_info.baseState;

                if (!baseState || !baseState.isAttached) {
                    return '';
                }

                let message = this.trans.msg.detach_from_portal;

                message = message.replace(':address', baseState.portalAddress);

                return message;
            },
            attacheBaseCallback() {
                location.href = this.attachBaseUrl;
                sendGAEvent("База присоединена к порталу");
            },
            toggleDescription() {
                this.isExpanded = !this.isExpanded;
            },
            ...mapActions('baseList', {
                showDeleteBaseModal: 'showDeleteBaseModal',
                doShowActivateLicenseModal: 'showActivateLicenseModal',
            }),
            ...mapActions('messageBox', ['openMessageBox']),
            showDeleteModal(base) {
                if (!base.canDelete || !this.availableState.isAvailable) {
                    return;
                }

                this.showDeleteBaseModal(base);
            },
            showActivateLicenseModal(base) {
                if (!base.canEditLicense) {
                    return;
                }

                let baseStatusEndPoint = this.legacyImportStatusUrl.replace('base_hash', base.hash_id);
                let baseUrlLocal = baseUrl.replace('base_hash', base.hash_id);
                // Проверяем статус процесса
                axios.get(baseStatusEndPoint)
                    .then(response => {
                        if (response.data) {
                            // Если идет процесс импорта, то отправляем на base.show
                            location = baseUrlLocal;
                        } else {
                            // Если процесс импорта не идет, то показываем окно активации ключа
                            this.doShowActivateLicenseModal(base);
                        };
                    })
                    .catch(error => {
                        AppUtils.showServiceError(error);
                    });
            },
            ...mapActions('baseInviteAccept', ['showBaseInviteAcceptModal'])
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../sass/variables';
    .card-footer-item.disabled {
        opacity: 0.6;
        pointer-events: none;
    }

    .card-invite-wrapper {
        cursor: pointer;

        i.base-invite-icon {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            color: $info;
        }

        &:hover {
            i.base-invite-icon {
                color: $deep-sky-blue;
                animation: none;
            }
        }

        .card-wrapper {
            position: relative;
            filter: blur(1.5px);
            pointer-events: none;
        }
    }
</style>
